function IconForObjClass(objClass) {
  if (!objClass) {
    return "";
  }
  let icon = "";

  switch (objClass) {
    case "external":
      icon = "external-link-alt";
      break;
    case "ContactPage":
      icon = "user";
      break;
    case "EventPage":
      icon = "calendar";
      break;
    case "CoursePage":
      icon = "book-reader";
      break;
    case "BlogPost":
      icon = "book";
      break;
    case "Download":
      icon = "download";
      break;
    case "NewsPage":
      icon = "newspaper";
      break;
    default:
      icon = "arrow-circle-right";
      break;
  }
  return icon;
}

export default IconForObjClass;
